module.exports = __webpack_public_path__ + "4011820b.png";